import { getAllComponents } from '../../Events/CreateRulesPerPage';

const viewAnnotations = (editor) => {

    editor.Commands.add("view-annotations", {
        run() {
    
            editor.select('');
            if(editor.Commands.isActive('command-enable-drag-drop') === true){
                editor.stopCommand('command-enable-drag-drop');
            }
        
            const all = getAllComponents(editor.DomComponents.getWrapper());
        
            all.filter(comp => comp.attributes.attributes.annotationname === undefined ).map(comp => {
                comp.set('hoverable', false)
                comp.set('selectable',false);
                comp.set('editable',false);
                comp.set('droppable',false);
                return comp;
            })
        
            all.filter(comp => comp.attributes.attributes.annotationname !== undefined).map(comp => {
                    
                comp.set('selectable',false);
                comp.set('editable',false);
                comp.set('droppable',false);
                comp.set('custom-name',`ann-name : ${comp.attributes.attributes.annotationname}`);
                editor.CssComposer.setRule('.border-annotations',{
                'border': '3px solid #0c4d82 !important'
                })
                
                comp.addClass('.border-annotations');
                return comp;
            })

        },
    
        stop(){
    
            const all = getAllComponents(editor.DomComponents.getWrapper());
        
            all.map(comp => {
                comp.set('hoverable', true);
                comp.set('selectable',true);
                comp.set('editable',true);
                comp.set('droppable',true);
                comp.set('custom-name','')
        
                const classes = comp.getClasses();
        
                classes.filter( componentClass => componentClass === 'border-annotations').map( componentClass => {
                    comp.removeClass(componentClass);
                    return comp;
                })
                return comp;
            })
        }
    });

}

export default viewAnnotations;